export const VIP_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/VIPCustomComponent.json' as const;
export const VIP_COMPONENT_TYPE = 'Vip' as const;
